import { Col, Row } from "antd";
import styled from "@emotion/styled";
import CardChartIncome from "./CardChartIncome"
import TopRowReport from "./TopRowReport";
import TableSection from "./TableSection";
import DatePickerSearch from "./DatePickerSearch";
import { useState } from "react";
import { formatDates } from "utils/dateFormat";
import { format, addMonths } from "date-fns"; 

const DashboardReport = () => {
    const currentDate = new Date();
    const formattedCurrentDate = formatDates(currentDate); 
    const oneMonthAgo = addMonths(currentDate, -1);
    const formattedOneMonthAgo = format(oneMonthAgo, "yyyy-MM-dd");
    const [daterangePicker, setDateRangePicker] = useState<[string, string] | null>([formattedOneMonthAgo, formattedCurrentDate]);  

    const handleDatepicker = (val: any ) => {
      const startdate = new Date(val[0]);
      const enddate = new Date(val[1]);

      const formattedStartDate= formatDates(startdate); 
      const formattedEndDate = formatDates(enddate); 

      setDateRangePicker([formattedStartDate,formattedEndDate]);
  };  


  return (
    <WrapperAll>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
            <DatePickerSearch handleDatepicker={handleDatepicker} />
        </Col>
      </Row>
      
      {daterangePicker && <TopRowReport daterangePicker={daterangePicker} />}
      {daterangePicker && <TableSection daterangePicker={daterangePicker}  />}
      <WrapperCardMid>
        {/* <WrapperHearder>
          <TextHeader>มูลค่า</TextHeader>
        </WrapperHearder> */}
      </WrapperCardMid>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          {daterangePicker &&  <CardChartIncome daterangePicker={daterangePicker} />}
        </Col>
      </Row>
    </WrapperAll>
  );
};

export default DashboardReport;

const WrapperCardMid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
  height: 20px;
  padding-left: 10px;
`;

const WrapperHearder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const TextHeader = styled.p`
  font-size: 18px;
  font-weight: 600;
`;

const WrapperAll = styled.div`
    margin-bottom: 10px;
  `;